import { render, staticRenderFns } from "./DetalleEmpleado.vue?vue&type=template&id=7313d99e&scoped=true"
import script from "./DetalleEmpleado.vue?vue&type=script&lang=js"
export * from "./DetalleEmpleado.vue?vue&type=script&lang=js"
import style0 from "./DetalleEmpleado.vue?vue&type=style&index=0&id=7313d99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7313d99e",
  null
  
)

export default component.exports